/**
 * %100 DİNAMİK Koleksiyon Filtreleme Motoru
 * ==========================================
 * Hiçbir statik anahtar kelime içermez.
 * Tüm sınıflandırma Liquid tarafında (navigasyon menüsünden) yapılır
 * ve HTML'e data-gender-card attribute olarak yansıtılır.
 * 
 * JS sadece bu attribute'u okuyarak filtreleme yapar.
 */

(function () {
  function getCards() {
    return Array.from(document.querySelectorAll('[data-gender-card]'));
  }

  function applyFilter(gender) {
    const activeGender = gender || 'all';

    // 1. Sekme aktiflik durumunu güncelle
    document.querySelectorAll('[data-gender-tab]').forEach(function (btn) {
      var btnTab = btn.getAttribute('data-gender-tab');
      if (btnTab === activeGender) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
      }
    });

    // 2. Koleksiyon kartlarını filtrele
    var cards = getCards();
    cards.forEach(function (card) {
      var tag = (card.getAttribute('data-gender-card') || '').trim().toLowerCase();

      var show = false;

      if (activeGender === 'all') {
        // TÜMÜ: parent (kök) koleksiyonlar hariç her şeyi göster
        show = (tag !== 'parent-kadin' && tag !== 'parent-erkek');
      } else if (activeGender === 'kadin') {
        // KADIN: Sadece sub-kadin olanları göster
        show = (tag === 'sub-kadin');
      } else if (activeGender === 'erkek') {
        // ERKEK: Sadece sub-erkek olanları göster
        show = (tag === 'sub-erkek');
      }

      if (show) {
        card.style.display = '';
        card.style.opacity = '1';
      } else {
        card.style.display = 'none';
        card.style.opacity = '0';
      }
    });
  }

  window.initGenderFilter = function () {
    var tabs = document.querySelectorAll('[data-gender-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      if (tab._genderBound) return;
      tab._genderBound = true;
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var gender = this.getAttribute('data-gender-tab');
        applyFilter(gender);
      });
    });

    applyFilter('all');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initGenderFilter);
  } else {
    window.initGenderFilter();
  }
})();
